

















import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import MethodicalMaterialListResponse from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/MethodicalMaterialModels/MethodicalMaterialListResponse";
import { Route, RawLocation } from "vue-router";
import MethodicalMaterialTagListItem from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/MethodicalMaterialModels/MethodicalMaterialTagListItem";
@Component
export default class PageMethodicalMaterialsTagComponent extends Vue {
  materials: WsResponseModel<MethodicalMaterialListResponse> = null;
  tag: WsResponseModel<MethodicalMaterialTagListItem> = null;
  mounted() {
          this.$meta.setTitle('Методическая копилка');
    this.getList();
    this.getTag();
  }
  get tagId(): number {
    return Number(this.$route.params.tag);
  }
  getList() {
    this.$api.MethodicalMaterialsService.GetListEvent.once(
      this.onGetList.bind(this)
    );
    this.$api.MethodicalMaterialsService.GetList({
      TagId: this.tagId
    });
  }
  onGetList(response: WsResponseModel<MethodicalMaterialListResponse>) {
    this.materials = response;
  }
  getTag() {
    this.$api.MethodicalMaterialsService.GetTagByIdEvent.once(
      this.onGetTagById.bind(this)
    );
    this.$api.MethodicalMaterialsService.GetTagById(Number(this.tagId));
  }
  onGetTagById(response: WsResponseModel<MethodicalMaterialTagListItem>) {
    this.tag = response;
  }
  beforeRouteUpdate(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
  ) {
    next();
    console.log("beforeRouteUpdate getList", to.params);
    this.getList();
    this.getTag();
  }
}
